// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-overlay {
    position: fixed;
    inset: 0;
    z-index: 49;
    /* Ensure the overlay appears below the modal (z-index: 50) */
    background-color: rgba(0, 0, 0, 0.5);
    height: 100vh;
    width: 100vw;
    /* Semi-transparent black background */
}

.modal-container {
    max-height: 95%;
    overflow-y: scroll;
}

.modal-container::-webkit-scrollbar {
    display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.modal-container {
    -ms-overflow-style: none;
    /* IE and Edge */
    scrollbar-width: none;
    /* Firefox */
}`, "",{"version":3,"sources":["webpack://./src/components/ui/modal/modal.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,QAAQ;IACR,WAAW;IACX,6DAA6D;IAC7D,oCAAoC;IACpC,aAAa;IACb,YAAY;IACZ,sCAAsC;AAC1C;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA,4CAA4C;AAC5C;IACI,wBAAwB;IACxB,gBAAgB;IAChB,qBAAqB;IACrB,YAAY;AAChB","sourcesContent":[".modal-overlay {\n    position: fixed;\n    inset: 0;\n    z-index: 49;\n    /* Ensure the overlay appears below the modal (z-index: 50) */\n    background-color: rgba(0, 0, 0, 0.5);\n    height: 100vh;\n    width: 100vw;\n    /* Semi-transparent black background */\n}\n\n.modal-container {\n    max-height: 95%;\n    overflow-y: scroll;\n}\n\n.modal-container::-webkit-scrollbar {\n    display: none;\n}\n\n/* Hide scrollbar for IE, Edge and Firefox */\n.modal-container {\n    -ms-overflow-style: none;\n    /* IE and Edge */\n    scrollbar-width: none;\n    /* Firefox */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
